'use strict';

// Native validation remains the fallback when JavaScript is unavailable.
(function () {
    const german = /^de(?:-|$)/i.test(document.documentElement.lang);
    const messages = german ? {
        required: 'Bitte füllen Sie dieses Pflichtfeld aus.',
        consent: 'Bitte bestätigen Sie dieses Pflichtfeld.',
        select: 'Bitte wählen Sie eine Option aus.',
        email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
        url: 'Bitte geben Sie eine gültige Webadresse ein (https://…).',
        mismatch: 'Die Passwörter stimmen nicht überein.',
        invalid: 'Bitte prüfen Sie Ihre Eingabe.',
    } : {
        required: 'Please complete this required field.',
        consent: 'Please confirm this required field.',
        select: 'Please select an option.',
        email: 'Please enter a valid email address.',
        url: 'Please enter a valid web address (https://…).',
        mismatch: 'The passwords do not match.',
        invalid: 'Please check your input.',
    };

    document.querySelectorAll('form').forEach((form, formIndex) => {
        if (!form.querySelector('.cc-form-page, #registration-username, #tx-felogin-input-username')) {
            return;
        }
        const errors = new Map();
        let submitted = false;
        const fields = () => Array.from(form.elements).filter((field) =>
            field.matches('input, select, textarea') && field.willValidate &&
            !field.closest('[aria-hidden="true"]')
        );

        function errorMessage(field) {
            if (field.validity.valueMissing || (field.required &&
                !['checkbox', 'radio', 'file'].includes(field.type) && !field.value.trim())) {
                return field.type === 'checkbox' || field.type === 'radio' ? messages.consent
                    : field.tagName === 'SELECT' ? messages.select : messages.required;
            }
            if (field.id === 'registration-passwordRepeat' && field.value &&
                field.value !== form.querySelector('#registration-password').value) {
                return field.dataset.passwordMismatchMessage || messages.mismatch;
            }
            if (field.validity.typeMismatch) {
                return field.type === 'email' ? messages.email : messages.url;
            }
            return field.validity.valid ? '' : messages.invalid;
        }

        function validate(field) {
            const message = errorMessage(field);
            let error = errors.get(field);
            if (!message) {
                if (error) {
                    const descriptions = (field.getAttribute('aria-describedby') || '')
                        .split(/\s+/).filter((id) => id && id !== error.id);
                    if (descriptions.length) {
                        field.setAttribute('aria-describedby', descriptions.join(' '));
                    } else {
                        field.removeAttribute('aria-describedby');
                    }
                    field.removeAttribute('aria-invalid');
                    field.classList.remove('cc-field-invalid');
                    error.remove();
                    errors.delete(field);
                }
                return true;
            }
            if (!error) {
                error = document.createElement('p');
                error.id = `cc-client-error-${formIndex}-${Array.from(form.elements).indexOf(field)}`;
                error.className = 'cc-field-error';
                const wrapper = field.closest('label') || field;
                wrapper.insertAdjacentElement('afterend', error);
                errors.set(field, error);
                const descriptions = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
                field.setAttribute('aria-describedby', [...descriptions, error.id].join(' '));
            }
            error.textContent = message;
            field.setAttribute('aria-invalid', 'true');
            field.classList.add('cc-field-invalid');
            return false;
        }

        form.addEventListener('submit', (event) => {
            if (event.submitter?.formNoValidate || event.submitter?.matches('.btn-secondary, .btn-cancel')) {
                return;
            }
            submitted = true;
            const invalid = fields().filter((field) => !validate(field));
            if (invalid.length) {
                event.preventDefault();
                invalid[0].focus();
            }
        });

        function update(event) {
            if (!submitted || !fields().includes(event.target)) {
                return;
            }
            validate(event.target);
            if (event.target.id === 'registration-password') {
                validate(form.querySelector('#registration-passwordRepeat'));
            }
        }
        form.addEventListener('input', update);
        form.addEventListener('change', update);
        form.noValidate = true;
    });
})();
